import React, { useEffect } from 'react';

import { Input } from 'reactstrap';
import {
   cityInput$,
   stateInput$,
   zipObservable$,
} from 'ui/util/rxjs/observables';
import { getCityStateFromZip } from 'app/employer/services/autofill';

// Auto fills city and state if there are 5 digits entered
const ReduxZipInputAutofill = (props) => {
   useEffect(() => {
      const subscription = zipObservable$.subscribe((zip) => {
         props.input.onChange(zip);
      });
      return () => {
         subscription.unsubscribe();
      };
   }, []);

   useEffect(() => {
      const { value } = props.input;
      let zipCitySubscription = null;
      if (value.length >= 4) {
         zipCitySubscription = getCityStateFromZip(value).subscribe(({ found, city, state }) => {
            if (found) {
               cityInput$.next(city);
               stateInput$.next(state);
            }
         });
      }
      return () => {
         if (zipCitySubscription && zipCitySubscription.unsubscribe) {
            zipCitySubscription.unsubscribe();
         }
      };
   }, [props.input.value]);

   return (
      <Input
         type='text'
         value={props.input.value}
         {...(props.meta.touched ? { valid: !props.meta.error } : {})} {...props.input} {...props}
         className={props.meta.touched && props.meta.error ? ' is-invalid ' : ''}
      />
   );
};

export default ReduxZipInputAutofill;
